<div class="supplementary-equipment">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'Begleitmittel' | translate: ['tmc.transport.supplementaryEquipment.takeBack.title',
      translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      {{handout.name}} {{handout.firstname}} {{handout.company}}
    </div>

    <div class="dialog-content" [formGroup]="formGroup">
      <sc-flex [vertical]="true" [stretchContent]="true" class="no-field-space">

        <ng-container *ngIf="supplementaryEquipmendHandouted(handout)">
          <ng-container *ngFor="let se of handout.supplementaryEquipments; let i = index">

            <sc-content-spacer [vertical]="true" *ngIf="i > 0"></sc-content-spacer>

            <sc-flex [formGroupName]="se.key+i">
              <sc-checkbox-field [disabled]="isFormReadonly()"
                  [label]="se.dictionaryKey | translate:[se.dictionaryKey, translationService.language]"
                  formControlName="selected"></sc-checkbox-field>
              <ng-container *ngIf="se.identifier">
                <sc-content-spacer></sc-content-spacer>
                <sc-string-field [disabled]="true"
                                  [label]="'Identifier' | translate: ['tmc-common.entity.equipment.identifier', translationService.language]"
                                  formControlName="identifier"></sc-string-field>
              </ng-container>
              <sc-content-spacer></sc-content-spacer>
                <sc-string-field [disabled]="true" *ngIf="isParam1Available(se)"
                  [label]="se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]"
                  formControlName="parameter1Value"></sc-string-field>
            </sc-flex>

          </ng-container>
        </ng-container>

        <div *ngIf="!supplementaryEquipmendHandouted(handout)">
          {{'Begleitmittel' | translate:
          ['tmc.transport.supplementaryEquipment.takeBack.label.nosupplementaryequipmenthandout',
          translationService.language]}}
        </div>

      </sc-flex>
    </div>

    <i class="horizontal-divider"></i>

    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancel()">{{'cancel' | translate:
        ['tmc.transport.supplementaryEquipment.takeBack.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="save()" class="confirm-button" [disabled]="isSaveDisabled()">{{'save' |
        translate: ['tmc.transport.supplementaryEquipment.takeBack.action.save',
        translationService.language]}}</button>
    </sc-actionbar>
  </div>

</div>
